<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="controller">
    <v-row class="max-w">
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          class="mx-4"
        >
          <div class="display-1 font-weight-bold text--primary mb-3 w-80">
            {{ $t('Usun-ster') }}
          </div>
          <div class="font-weight-light mb-4 c-lighter-1">
            {{ $t('usun-ster-opis') }}
          </div>
          
          <v-list
            v-if="controller"
            one-line
            flat
            class="transparent"
          >
            <v-list-item class="br-3 my-2">
              <v-list-item-icon>
                <v-icon>mdi-delete</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ controller.displayName }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <div class="text-center mt-8">
            <v-btn 
            :loading="saving"
            :disabled="saving" 
            @click="postForm"
            x-large class="w-100" color="primary">{{ $t('Usun-ster') }}</v-btn>

          <v-btn text x-large @click="$router.go(-1)" class="w-100 mt-2">
            {{ $t('anuluj') }}
          </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data: () => ({
    valid: true,
    displayName: '',
    displayNameRules: [
      v => !!v || 'Podaj własną nazwę sterownika',
      v => (v && v.length > 2 && v.length <26) || 'Nazwa sterownika musi mieć od 3 do 25 znaków'
    ],
    saving: false,
    success: false
  }),
  computed: {
    ...mapGetters([
      'token', 'controllerById'
    ]),
    controllerId() {
      return this.$route.params.controllerId
    },
    controller() {
      return this.controllerById(this.controllerId)
    }
  },
  methods: {
    ...mapActions([
      'deleteController',
      'syncControllers'
    ]),
    postForm () {
      this.saving = true;
      
      this.deleteController({
        controllerId: this.controllerId
      })
      .then(res => {
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.saving = false;
        } else {
          this.syncControllers(true).then(res => {
            this.saving = false;
            this.$router.push({ path: '/controllers' });
          })
        }
      });
    }
  },
  created () {
    this.displayName = this.controller.displayName;
  }
}
</script>

<style>
</style>

